export default __webpack_public_path__ + "static/media/zahrada1.772dc995.jpeg";